import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { shiftMonth } from '@/lib/calendar/monthGrid';

/**
 * Month stepping.
 *
 * The month lives in the URL, not in component state, so a clinician can send
 * someone a link to the month they are talking about and the back button steps
 * months. `onChange` is expected to navigate rather than setState.
 */
export function MonthNav({ month, onChange }: { month: string; onChange: (month: string) => void }) {
  const label = new Date(`${month}-01T00:00:00`).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="flex items-center gap-2">
      <Button
        size="icon"
        variant="outline"
        aria-label="Previous month"
        onClick={() => onChange(shiftMonth(month, -1))}
      >
        <ChevronLeft className="size-4" />
      </Button>
      <span className="min-w-[10ch] text-center text-[17px] font-medium">{label}</span>
      <Button size="icon" variant="outline" aria-label="Next month" onClick={() => onChange(shiftMonth(month, 1))}>
        <ChevronRight className="size-4" />
      </Button>
    </div>
  );
}
